import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [school, setSchool] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [graceDaysRemaining, setGraceDaysRemaining] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('eduva_token');
    if (token) {
      api.get('/auth/me')
        .then((res) => {
          setUser(res.user);
          setSchool(res.school);
          setSubscriptionStatus(res.subscription_status || null);
          setGraceDaysRemaining(res.grace_days_remaining ?? null);
        })
        .catch(() => {
          localStorage.removeItem('eduva_token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData, schoolData, subStatus, graceDays) => {
    localStorage.setItem('eduva_token', token);
    setUser(userData);
    setSchool(schoolData);
    setSubscriptionStatus(subStatus || null);
    setGraceDaysRemaining(graceDays ?? null);
  };

  const logout = () => {
    localStorage.removeItem('eduva_token');
    setUser(null);
    setSchool(null);
    setSubscriptionStatus(null);
    setGraceDaysRemaining(null);
    window.location.href = '/';
  };

  const updateSchool = (schoolData) => setSchool(schoolData);

  return (
    <AuthContext.Provider value={{ user, school, loading, login, logout, updateSchool, subscriptionStatus, graceDaysRemaining }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export default AuthContext;
